export default class DevError extends Error {
  isFriendly: boolean;
  code: string;
  context: string;

  constructor(message: string, opts: { code?: string; context?: string } = {}) {
    super(message);
    this.isFriendly = false;
    this.code = opts.code || 'ERRPROBLEMBETWEENCHAIRANDKEYBOARD';
    this.context = opts.context || 'HUMAN';
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
